



















































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
@Component({
  components: {}
})
export default class extends Vue {
  //注入数据 @Provide()
  @Provide()
  private AddaccountForm = {
    way: 1,
    name: "",
    usde: "",
    code: ""
  };
  private providetype = [
    { key: "1", value: "湖南省" },
    { key: "2", value: "湖北省" },
    { key: "3", value: "广东省" }
  ];
  private citytype = [
    { key: "1", value: "长沙市" },
    { key: "2", value: "岳阳市" },
    { key: "3", value: "常德市" }
  ];
  //取消方法
  cancle() {
    this.$emit("backtable");
  }
}
